"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryDocumentPermissionsMap = exports.arbitraryAnonymousDocumentPermissionsData = exports.arbitraryAtLeastViewDocumentPermissionsData = exports.arbitraryNoAccessDocumentPermissionsData = exports.arbitraryDocumentPermissionsData = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("@buildwithflux/constants");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const permission_1 = require("../../src/permission");
const identifier_1 = require("./identifier");
const arbitraryPermissionType = fast_check_1.default.constantFrom(permission_1.PermissionType.comment, permission_1.PermissionType.edit, permission_1.PermissionType.view, permission_1.PermissionType.none);
/**
 * Generate completely arbitrary user permissions.
 */
exports.arbitraryDocumentPermissionsData = fast_check_1.default
    .tuple(identifier_1.arbitraryUserUid, arbitraryPermissionType, fast_check_1.default.option(fast_check_1.default.nat()))
    .map(([userUid, permissionType, maybeUpdatedCreatedDiff]) => {
    const createdAt = Date.now();
    const updatedAt = maybeUpdatedCreatedDiff ? createdAt + maybeUpdatedCreatedDiff : createdAt;
    return {
        user_uid: userUid,
        permission_type: permissionType,
        created_at: createdAt,
        updated_at: updatedAt,
    };
});
/**
 * Generate arbitrary user permissions where the user in question is granted no access i.e. permission type is "none"
 */
exports.arbitraryNoAccessDocumentPermissionsData = exports.arbitraryDocumentPermissionsData.filter((perms) => perms.permission_type === permission_1.PermissionType.none);
/**
 * Generate arbitrary user permissions where the user in question has at least view permission.
 */
exports.arbitraryAtLeastViewDocumentPermissionsData = exports.arbitraryDocumentPermissionsData.filter((perms) => perms.permission_type !== permission_1.PermissionType.none);
/**
 * Arbitrary permissions for the anonymous user.
 */
exports.arbitraryAnonymousDocumentPermissionsData = arbitraryPermissionType.map((permission) => (0, permission_1.createUserPermissionsForUser)(constants_1.ANON_ROLE_UID, permission));
/**
 * An arbitrary permissions map.  Includes at the very least the anonymous user (with some arbitrary level of permission).
 */
exports.arbitraryDocumentPermissionsMap = fast_check_1.default
    .tuple(exports.arbitraryAnonymousDocumentPermissionsData, fast_check_1.default.array(exports.arbitraryDocumentPermissionsData))
    .map(([anonymousPerms, otherPermsList]) => (0, permission_1.userPermissionsToPermissionsMap)([anonymousPerms, ...otherPermsList]));
//# sourceMappingURL=permissions.js.map